// Pathless layout for the Finnish URL tree. Forces UI language to "fi" so
// the existing translation pipeline (UI strings + AI-translated item fields)
// renders Finnish content under /fi/*. No visual chrome — just <Outlet />.
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

export const Route = createFileRoute("/fi")({
  component: FiLayout,
});

function FiLayout() {
  const { setLang } = useLanguage();
  // Mount-only: set Finnish when entering the /fi tree. Re-running on `lang`
  // would fight the language switcher — picking English fires setLang("en"),
  // this effect would immediately force "fi" back before the route unmounts.
  useEffect(() => {
    setLang("fi");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Outlet />;
}

